<template>
    <div class="cart">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col col-sm-11 col-md-10 col-lg-9">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Breadcrumbs from '@/components/partial/Breadcrumbs'

    export default {
        data(){
            return{
                crumbsItem: [{
                        text: '首頁',
                        to: '/',
                    },
                    {
                        text: '常見問題',
                        active: true
                    }
                ],
            }
        },
        components:{
            Breadcrumbs,
        },
    }
</script>
